import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AppinfoDefaults } from './appinfo.service';

// Lbe setting's submenu config
export interface LbeSettingConfig {
	hasFooter: boolean; // The sub menu has footer or not
	title: string; // Sub menu's title
}

@Injectable()
export class LbeSettingService {

	public lbeDefaults: AppinfoDefaults; // This is set after entering lbe-setting component

	// Lbe setting's submenu config
	settingConfig: BehaviorSubject<LbeSettingConfig> = new BehaviorSubject(null);
	constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/common-services/lbe-setting.service.ts